import { JetView } from 'webix-jet';
import { devConfig, profile } from 'config/config';

/**
 * Class representing the view for table balance adjustments.
 * @extends JetView
 */
export default class tableBalanceAdjustmentsView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        return {
            rows: [
                {
                    cols: [
                        {
                            type: 'wide',
                            view: 'datatable',
                            id: 'datatable',
                            css: 'webix_header_border webix_data_border webix_footer_border',
                            select: true,
                            columns: [
                                {
                                    id: 'ActionTittle',
                                    header: '',
                                    width: 50,
                                    height: 25,
                                    tooltip: _('Acción'),
                                    /**
                                     * Template function to render action icon based on state.
                                     * @param {Object} obj - The data object for the row.
                                     * @returns {String} HTML string for the action icon.
                                     */
                                    template: function (obj) {
                                        if (obj.State == '0') {
                                            return "<span class='webix_icon wxi-close torefuse'></span>";
                                        } else {
                                            return '';
                                        }
                                    },
                                },
                                { id: 'Id', header: _('Id'), width: 100 },
                                {
                                    id: 'UserName',
                                    header: _('Usuario'),
                                    width: 250,
                                },
                                {
                                    id: 'Account',
                                    header: _('Número de cuenta'),
                                    width: 150,
                                },
                                {
                                    id: 'InterbankCode',
                                    header: _('Código Interbancario'),
                                    width: 150,
                                    hidden: profile.Settings.ReportCountry != '173',
                                },
                                {
                                    id: 'TypeAccount',
                                    header: _('Tipo de cuenta'),
                                    width: 150,
                                },
                                { id: 'Bank', header: _('Banco'), width: 150 },
                                {
                                    id: 'State',
                                    header: _('Estado'),
                                    width: 150,
                                    options: [
                                        { id: '0', value: _('Activa') },
                                        { id: '1', value: _('Inactiva') },
                                    ],
                                },
                                { id: 'Coin', header: _('Moneda'), width: 150 },
                            ],
                            on: {
                                /**
                                 * Event handler for before loading data into the datatable.
                                 */
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                /**
                                 * Event handler for after loading data into the datatable.
                                 */
                                onAfterLoad: function () {
                                    this.hideOverlay();
                                },
                            },
                            /**
                             * Event handler for when the datatable is ready.
                             */
                            ready: function () {
                                if (!this.count()) {
                                    webix.extend(this, webix.OverlayBox);
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    );
                                }
                            },
                            onClick: {
                                /**
                                 * Event handler for clicking the action icon to refuse an account.
                                 * @param {Event} euv - The event object.
                                 * @param {String} id - The ID of the clicked item.
                                 */
                                torefuse: function (euv, id) {
                                    var vvthis = this;
                                    webix.confirm({
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea inactivar cuenta bancaria?'),
                                        ok: _('Inactivar cuenta'),
                                        cancel: _('Salir'),
                                        callback: function (action) {
                                            if (action === true) {
                                                var item = vvthis.getItem(id);
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json',
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'BankCommisions/CancelAccount',
                                                        '{ "Id":' + item.Id + '}',
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message('Error! ');
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                var resp = JSON.parse(text);
                                                                if (!resp.HasError) {
                                                                    item.State = '1';
                                                                    webix.message(_('Cuenta bancaria inactivada'));
                                                                    vthis.$$('datatable').refresh();
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                            },
                            tooltip: true,
                            math: true,
                            loadahead: 0,
                            datafetch: devConfig.getDefaultDataFetch(),
                            pager: 'pagerA',
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._;
        grid = $$('datatable');
        var url = devConfig.geturlApi() + 'Financial/GetBankAccountsComissions';
        var optionsBanks = [];
        var popupAdd;
        var filter = '';
        this.on(this.app, 'report:filter', (filterData) => {
            var object = Object.entries(filterData);
            var string1 = '';
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', '');
                                string1 = string1 + '&dateFrom=' + date;
                                string1 = string1 + '&dateTo=' + date;
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll();
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            filter = string1;
            $$('filterPopup').hide();
        });
        this.on(this.app, 'add:button', (item) => {
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json',
                })
                .post(devConfig.geturlApi() + 'Financial/GetBanksComissions', '', {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message('Error! ');
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var resp = JSON.parse(text);
                        optionsBanks = resp.Data;
                        popupAdd = webix.ui({
                            view: 'window',
                            height: 550,
                            head: {
                                view: 'toolbar',
                                cols: [
                                    {
                                        view: 'label',
                                        label: _('Agregar Cuenta'),
                                        align: 'center',
                                    },
                                    {
                                        view: 'icon',
                                        icon: 'wxi-close',
                                        click: function () {
                                            this.getTopParentView().hide();
                                        },
                                    },
                                ],
                            },
                            position: 'center',
                            modal: true,
                            body: {
                                view: 'form',
                                id: 'addform',
                                elements: [
                                    {
                                        view: 'text',
                                        label: _('Número de cuenta') + ':',
                                        name: 'Account',
                                        labelWidth: 150,
                                        labelPosition: 'top',
                                        type: 'number',
                                        required: true,
                                    },
                                    {
                                        view: 'combo',
                                        label: _('Tipo de cuenta') + ':',
                                        name: 'TypeAccount',
                                        required: true,
                                        labelPosition: 'top',
                                        options: [
                                            {
                                                id: '0',
                                                value: _('Ahorros'),
                                            },
                                            {
                                                id: '1',
                                                value: _('Corriente'),
                                            },
                                            { id: 'EVP', value: _('EVP') },
                                            { id: 'CPF', value: _('CPF') },
                                            {
                                                id: 'PHONE',
                                                value: _('PHONE'),
                                            },
                                            {
                                                id: 'EMAIL',
                                                value: _('EMAIL'),
                                            },
                                        ],
                                        labelWidth: 150,
                                    },
                                    {
                                        view: 'text',
                                        label: _('Código Interbancario') + ':',
                                        name: 'InterbankCode',
                                        labelWidth: 150,
                                        labelPosition: 'top',
                                        type: 'number',
                                        hidden: profile.Settings.ReportCountry != '173',
                                        required: true,
                                    },
                                    {
                                        view: 'combo',
                                        label: _('Banco') + ':',
                                        name: 'Bank',
                                        labelWidth: 150,
                                        labelPosition: 'top',
                                        required: true,
                                        options: optionsBanks,
                                    },
                                    {
                                        cols: [
                                            {
                                                view: 'button',
                                                value: _('Cancelar'),
                                                click: function () {
                                                    this.getTopParentView().hide();
                                                    $$('addform').setValues($$('addform').getCleanValues());
                                                },
                                            },
                                            {
                                                view: 'button',
                                                type: 'form',
                                                value: _('Guardar'),
                                                click: function ($e) {
                                                    var values = $$('addform').getValues();
                                                    if ($$('addform').validate()) {
                                                        webix
                                                            .ajax()
                                                            .headers({
                                                                'Content-type': 'application/json',
                                                            })
                                                            .post(
                                                                devConfig.geturlApi() + '/es/Financial/AddBankAccount',
                                                                values,
                                                                {
                                                                    error: function (text, data, XmlHttpRequest) {
                                                                        webix.message('Error! ');
                                                                    },
                                                                    success: function (text, data, XmlHttpRequest) {
                                                                        var json = JSON.parse(text);
                                                                        if (json.HasError) {
                                                                            webix.message({
                                                                                title: _('¡Error!'),
                                                                                type: 'alert-error',
                                                                                text: json.AlertMessage,
                                                                            });
                                                                        } else {
                                                                            webix.message('Cuenta bancaria creada');
                                                                            grid.clearAll();
                                                                            grid.load(
                                                                                url +
                                                                                    '?start=0&count=' +
                                                                                    grid.data.$pagesize +
                                                                                    filter,
                                                                            );
                                                                        }
                                                                    },
                                                                },
                                                            );
                                                        $$('addform').setValues($$('addform').getCleanValues());
                                                        this.getTopParentView().hide();
                                                    } else {
                                                        webix.message({
                                                            title: _('¡Error!'),
                                                            type: 'alert-error',
                                                            text: _('Completa los campos...'),
                                                        });
                                                    }
                                                },
                                            },
                                        ],
                                    },
                                ],
                                elementsConfig: {
                                    on: {
                                        /**
                                         * Event handler for form field change to validate the form.
                                         */
                                        onChange: function () {
                                            this.validate();
                                        },
                                    },
                                },
                            },
                        });
                        popupAdd.show();
                        $$('addform').clearValidation();
                    },
                });
        });
    }
}

// FILE DOCUMENTED
